import { useQuery } from '@tanstack/react-query'
import { getFileStructure } from '../api/data-connectors/file-structure'

export function useGetFileStructure(fileId: string, enabled: boolean = true) {
  return useQuery({
    queryKey: ['FileStructure', fileId],
    queryFn: () => getFileStructure(fileId),
    staleTime: 600000, // 10 minutes
    enabled,
  })
}
